export default function CompareAccounts() {
  let prevScrollTop = 0;
  let currentScrollTop = 0;
  let fxiTopHeader = document.querySelector(".fxi-top-header");
  let compareAccBtns = document.getElementsByClassName(
    "compare-accounts_sm-btns"
  )[0];

  window.addEventListener("scroll", function () {
    const a = window.scrollY;
    const b = fxiTopHeader && fxiTopHeader.clientHeight;

    currentScrollTop = a;

    if (prevScrollTop < currentScrollTop && a > b + b) {
      compareAccBtns &&
        compareAccBtns.classList.remove("compare-accounts_sm-scroll-down");
    } else if (prevScrollTop > currentScrollTop && !(a <= b)) {
      compareAccBtns &&
        compareAccBtns.classList.add("compare-accounts_sm-scroll-down");
    }
    prevScrollTop = currentScrollTop;
  });
}
